import {
  User,
  Clapperboard,
  CalendarClock,
  Banknote,
  UserCircle,
  Lock,
  Hash,
  KeyRound,
  type LucideIcon,
} from "lucide-react";

export interface TemplateVariableDef {
  key: string;
  label: string;
  description: string;
  example: string;
  icon: LucideIcon;
}

export const AVAILABLE_TEMPLATE_VARIABLES: TemplateVariableDef[] = [
  {
    key: "nombre",
    label: "Nombre",
    description: "Nombre del cliente",
    example: "Juan Pérez",
    icon: User,
  },
  {
    key: "servicio",
    label: "Servicio",
    description: "Nombre del servicio (Netflix, HBO, etc.)",
    example: "Netflix",
    icon: Clapperboard,
  },
  {
    key: "fecha_vencimiento",
    label: "Vencimiento",
    description: "Fecha en que vence la suscripción del cliente",
    example: "15/08/2026",
    icon: CalendarClock,
  },
  {
    key: "monto",
    label: "Monto",
    description: "Precio de la suscripción",
    example: "$10.00",
    icon: Banknote,
  },
  {
    key: "usuario",
    label: "Usuario",
    description: "Usuario con el que el cliente accede a la cuenta",
    example: "cliente@correo.com",
    icon: UserCircle,
  },
  {
    key: "contrasena",
    label: "Contraseña",
    description: "Contraseña con la que el cliente accede a la cuenta",
    example: "Abc12345",
    icon: Lock,
  },
  {
    key: "slotName",
    label: "Perfil",
    description: "Nombre del perfil asignado al cliente",
    example: "Perfil 2",
    icon: Hash,
  },
  {
    key: "slotPin",
    label: "PIN de perfil",
    description: "PIN de acceso al perfil del cliente",
    example: "4821",
    icon: KeyRound,
  },
];

export function extractVariablesFromBody(body: string): string[] {
  const matches = [...body.matchAll(/\{\{\s*([\w.]+)\s*\}\}/g)].map((m) => m[1]);
  return Array.from(new Set(matches));
}

export function buildTemplatePreview(body: string): string {
  return AVAILABLE_TEMPLATE_VARIABLES.reduce(
    (text, variable) => text.split(`{{${variable.key}}}`).join(variable.example),
    body,
  );
}
